import { differenceInSeconds, parse } from "date-fns";
import { getMessagesToVerifyIfActivationIsCompleted } from "../actions";
import { ingDeskService } from "../services/IngDesk/ingDeskService";

class ClientWalletIntegration {
  countNumbersOfMessagesOfEachOne(messages) {
    const result = {
      operatorMessages: 0,
      clientMessages: 0,
    };
    const hasMessages = Array.isArray(messages) && messages.length > 0;
    if (!hasMessages) return result;
    messages.forEach((message) => {
      const isFromOperator = message.agente === true;
      if (isFromOperator) {
        result.operatorMessages = result.operatorMessages + 1;
      } else {
        result.clientMessages = result.clientMessages + 1;
      }
    });

    return result;
  }
  verifyIfActivationIsCompleted(rule, dataOfAttendance) {
    switch (rule.typeOfRule) {
      case "digital":
        const hasMessages =
          Array.isArray(dataOfAttendance.messages) &&
          dataOfAttendance.messages.length > 0;
        if (!hasMessages && rule.value === 0) return true;
        if (!hasMessages && rule.value !== 0) return false;
        const { operatorMessages, clientMessages } =
          this.countNumbersOfMessagesOfEachOne(dataOfAttendance.messages);
        if (
          hasMessages &&
          operatorMessages >= rule.value &&
          clientMessages >= rule.value
        )
          return true;
        return false;
      case "voice":
        const duration = dataOfAttendance.duration;
        if (duration >= rule.value) return true;
        return false;
      default:
        return false;
    }
  }

  async getRulesToCompleteActivationInClientWallet(channelId, baseUrl, token) {
    const response = await ingDeskService.ListarGiroCarteiraMetricas(
      channelId,
      baseUrl,
      token,
    );
    const hasResponse = Boolean(response) && response.status === 200;
    if (!hasResponse) return null;
    const hasData = Array.isArray(response.data) && response.data.length > 0;
    if (!hasData) return null;
    const isDigital = parseInt(channelId) !== 1;
    if (isDigital)
      return {
        typeOfRule: "digital",
        value: response.data[0].valor,
      };

    return {
      typeOfRule: "voice",
      value: response.data[0].valor,
    };
  }

  async getContactAndEnterpriseIdByPhone(telefone, baseUrl, token) {
    const defaultValue = {
      id_contato: null,
      id_empresa: null,
    };
    const response = await ingDeskService.getContatoGiroCarteira(
      telefone,
      baseUrl,
      token,
    );
    const hasResponse = Boolean(response) && response.status === 200;
    if (!hasResponse) return defaultValue;
    const hasData = Boolean(response.data);
    if (!hasData) return defaultValue;
    const hasContactWithThisPhone = response.data.exists;
    if (!hasContactWithThisPhone) return defaultValue;
    const hasContactData = Boolean(response.data.contato);
    if (!hasContactData) return defaultValue;
    return {
      id_contato: response.data.contato.id_contato,
      id_empresa:
        Boolean(response.data.contato.id_empresa) ||
        response.data.contato.id_empresa === 0
          ? response.data.contato.id_empresa
          : null,
    };
  }

  async getContactIdByPhone(telefone, baseUrl, token) {
    const response = await ingDeskService.getContatoGiroCarteira(
      telefone,
      baseUrl,
      token,
    );
    const hasResponse = Boolean(response) && response.status === 200;
    if (!hasResponse) return null;
    const hasData = Boolean(response.data);
    if (!hasData) return null;
    const hasContactWithThisPhone = response.data.exists;
    if (!hasContactWithThisPhone) return null;
    const hasContactData = Boolean(response.data.contato);
    if (!hasContactData) return null;
    return response.data.contato.id_contato;
  }

  async isAlreadyInClientWallet(cdr, baseUrl, token) {
    const response = await ingDeskService.getGiroStatusByCdr(
      cdr,
      baseUrl,
      token,
    );
    const hasResponse = Boolean(response) && response.status === 200;
    if (!hasResponse) return false;
    const hasData = Boolean(response.data);
    if (!hasData) return false;
    return response.data.in_giro;
  }

  async handleActivationCompleted(
    informationusers,
    cdr,
    telefone,
    channelId,
    duration = 0,
  ) {
    try {
      const baseUrl = informationusers.backendingdesk;
      const hasBaseUrl = Boolean(baseUrl);
      if (!hasBaseUrl) return;
      const loginUser = informationusers.username;
      const hasLoginUser = Boolean(loginUser);
      if (!hasLoginUser) return;

      const userDataInIngDesk = await ingDeskService.getIngDeskDataOfUser(
        baseUrl,
        loginUser,
      );
      const hasUserDataInIngDesk = Boolean(userDataInIngDesk);
      if (!hasUserDataInIngDesk) return;

      const token = userDataInIngDesk.token;
      const hasToken = Boolean(token);
      if (!hasToken) return;

      const isInClientWallet = await this.isAlreadyInClientWallet(
        cdr,
        baseUrl,
        token,
      );
      if (!isInClientWallet) return;
      const idOfContactInIngDesk = await this.getContactIdByPhone(
        telefone,
        baseUrl,
        token,
      );
      const hasIdOfContactInIngDesk =
        Boolean(idOfContactInIngDesk) || idOfContactInIngDesk === 0;
      if (!hasIdOfContactInIngDesk) return;

      const rule = await this.getRulesToCompleteActivationInClientWallet(
        channelId,
        baseUrl,
        token,
      );
      const hasRule = Boolean(rule);
      if (!hasRule) return;

      let isCompleted = false;
      if (rule.typeOfRule === "voice") {
        isCompleted = this.verifyIfActivationIsCompleted(rule, { duration });
      }
      if (rule.typeOfRule === "digital") {
        const messages = await getMessagesToVerifyIfActivationIsCompleted(
          cdr,
          informationusers,
        );
        isCompleted = this.verifyIfActivationIsCompleted(rule, { messages });
      }
      if (!isCompleted) return;

      await ingDeskService.setSucessoGiroPorCdr(cdr, baseUrl, token);
    } catch (error) {
      console.log("handleActivationCompleted Error: ", error);
    }
  }

  //---

  async insertCallInClientWallet(
    cdr,
    idContatoInIngDesk,
    idUsuarioInIngDesk,
    channelId,
    baseUrl,
    token,
    id_empresa,
  ) {
    const payload = {
      cdrid: cdr,
      id_contato: idContatoInIngDesk,
      id_usuario: idUsuarioInIngDesk,
      id_canal: parseInt(channelId),
      id_empresa,
    };

    const response = await ingDeskService.insertInteractionContact(
      payload,
      baseUrl,
      token,
    );
  }

  getDurationOfCall(atdsimult, cdr) {
    try {
      const atdInformation = atdsimult.find(
        (atd) => parseInt(cdr) === parseInt(atd.idatendimento),
      );
      const hasAtdInformation = Boolean(atdInformation);
      if (!hasAtdInformation) return 0;
      const isVoice = parseInt(atdInformation.idmidia) === 1;
      if (!isVoice) return 0;
      const datatimeAtdString = atdInformation.datatimeatd;
      const datatimeAtd = parse(
        datatimeAtdString,
        "dd/MM/yyyy HH:mm:ss",
        new Date(),
      );
      const now = new Date();
      const duration = differenceInSeconds(now, datatimeAtd);
      const hasDuration = typeof duration === "number";
      if (!hasDuration) return 0;
      return duration;
    } catch (error) {
      return 0;
    }
  }

  getAtdInformation(atdsimult, cdr) {
    const information = {
      telefone: "",
      channelId: "",
      direction: "",
    };
    try {
      const atdInformation = atdsimult.find(
        (atd) => parseInt(cdr) === parseInt(atd.idatendimento),
      );
      const hasAtdInformation = Boolean(atdInformation);
      if (!hasAtdInformation) return information;
      const phoneNumber = atdInformation.telefone || "";
      const channelId = parseInt(atdInformation.idmidia) || "";
      const direction = atdInformation.direction || "";
      return {
        telefone: phoneNumber,
        channelId,
        direction,
      };
    } catch (error) {
      return information;
    }
  }

  async insertInClientWalletInIngDesk(
    informationusers,
    cdr,
    telefone,
    channelId,
  ) {
    try {
      const baseUrl = informationusers.backendingdesk;
      const hasBaseUrl = Boolean(baseUrl);
      if (!hasBaseUrl) return;
      const loginUser = informationusers.username;
      const hasLoginUser = Boolean(loginUser);
      if (!hasLoginUser) return;

      const userDataInIngDesk = await ingDeskService.getIngDeskDataOfUser(
        baseUrl,
        loginUser,
      );
      const hasUserDataInIngDesk = Boolean(userDataInIngDesk);
      if (!hasUserDataInIngDesk) return;

      const token = userDataInIngDesk.token;
      const hasToken = Boolean(token);
      if (!hasToken) return;

      const userIdInIngDesk = userDataInIngDesk.userIdInIngDesk;
      const hasUserIdInIngDesk =
        Boolean(userIdInIngDesk) || userIdInIngDesk === 0;
      if (!hasUserIdInIngDesk) return;

      const isInClientWallet = await this.isAlreadyInClientWallet(
        cdr,
        baseUrl,
        token,
      );
      if (isInClientWallet) return;

      const { id_contato: idOfContactInIngDesk, id_empresa } =
        await this.getContactAndEnterpriseIdByPhone(telefone, baseUrl, token);

      const hasIdOfContactInIngDesk =
        Boolean(idOfContactInIngDesk) || idOfContactInIngDesk === 0;
      if (!hasIdOfContactInIngDesk) return;

      await this.insertCallInClientWallet(
        cdr,
        idOfContactInIngDesk,
        userIdInIngDesk,
        channelId,
        baseUrl,
        token,
        id_empresa,
      );
    } catch (error) {
      console.log("insertInClientWalletInIngDesk Error: ", error);
    }
  }
}

export const clientWalletIntegration = new ClientWalletIntegration();
